<template>
  <div class="view pa24">
    <el-form :model="serchParams" class="demo-form-inline" :inline="true">
      <el-row style="padding-top: 20px;">
        <el-form-item label="产品" label-width="100px" label-position="left" class="fromItem">
          <el-select v-model="serchParams.classId" placeholder="请选择" clearable>
            <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间" label-width="100px" label-position="left" class="fromItem" prop="startTime">
          <el-date-picker v-model="serchParams.times" type="daterange" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-row>
    </el-form>
<!--    <div class="d-flex">-->
<!--      <el-button class="ma" type="primary" @click="handleAddDealer()">+添加仓库</el-button>-->
<!--    </div>-->
    <commonTable
        :tableData="tableData"
        :total="total"
        :currentPage="pageNum"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:table>
        <el-table-column
            prop="className"
            align="center"
            label="产品"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.className || '--'}}</div>
          </template>
        </el-table-column>
        <el-table-column
            prop="lotNumber"
            align="center"
            label="批次"
        >
          <template slot-scope="scope">
            {{ scope.row.lotNumber || '--'}}
          </template>
        </el-table-column>
        <el-table-column
            prop="num"
            align="center"
            label="数量"
        >
          <template slot-scope="scope">
            {{ scope.row.num || '--'}}
          </template>
        </el-table-column>
        <el-table-column
            prop="children"
            align="center"
            label="状态"
            v-if="false"
        >
          <template slot-scope="scope">
            <el-tag type="sucess" v-if="scope.row.status==1">已发货</el-tag>
            <el-tag  v-if="scope.row.status==0">进行中</el-tag>
            <el-tag type="info" v-if="scope.row.status==2">已收货</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="leader"
            align="center"
            label="快递信息"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">暂无快递信息</span>
            <el-button v-else type="text" @click="showExpress(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="下单时间"
        />
<!--        <el-table-column align="center" width="200" label="操作">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button type="text" @click="editDealar(scope.row)">编辑</el-button>-->
<!--            <el-button type="text" @click="deleteDealar(scope.row)" style="color: red">删除</el-button>-->
<!--            <el-popconfirm confirm-button-text="确定" cancel-button-text="取消"-->
<!--                           v-if="checkPermission(['warehouse_enabled'])"-->
<!--                           @confirm="enabled(scope.row)" icon="el-icon-info" icon-color="red" :title="`确定要${scope.row.enabled?'停用':'启用'}该仓库吗？`">-->
<!--              <el-button slot="reference" class="ml10" :class="scope.row.enabled?'text-color-red':'text-color-green'" type="text">{{scope.row.enabled?'停用':'启用'}}</el-button>-->
<!--            </el-popconfirm>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </template>
    </commonTable>

    <el-dialog
        title="快递信息"
        :visible.sync="dialogVisible" append-to-body
        width="30%">
      <div class="express-info">
        <el-row class="info-row">
          <el-col :span="24">
            <div class="info-item">
              <span class="label">快递公司：</span>
              <span class="value">{{express.expressName}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="info-row">
          <el-col :span="24">
            <div class="info-item">
              <span class="label">快递单号：</span>
              <span class="value">{{express.expressNumber}}</span>
              <span class="copyTxt" @click="copy(express.expressNumber)" v-if="express.expressNumber"><img src="../../assets/images/fz.png" /></span>
            </div>
          </el-col>
        </el-row>
        <el-row class="info-row">
          <el-col :span="24">
            <div class="info-item">
              <span class="label">发货时间：</span>
              <span class="value">{{express.sendTime}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import {get} from "@/utils/request";
import {checkPermission} from "@/directives/permission";
import {selectOrder} from "@/api/printOrder.js"
import {noPage} from "../../api/customPageClass";
export default {
  name: "dealerList",
  components: {
    commonTable
  },
  data() {
    return {
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      dialogVisible:false,
      express:{},
      typeList:[],
      serchParams: {
        classId: '',
        times:[]
      },
    };
  },
  created() {
    this.getList()
    noPage({type:0}).then(response=>{
      if (response.data){
        this.typeList = response.data
      }
    })
  },
  methods: {
    checkPermission,
    copy(context) {
      // 创建输入框元素
      let oInput = document.createElement('input');
      // 将想要复制的值
      oInput.value = context;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand('Copy');
      // 弹出复制成功信息
      this.$message.success('复制成功');
      // 复制后移除输入框
      oInput.remove();
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.serchParams
      }
      selectOrder(params).then(res=>{
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    showExpress(row){
      console.log('row',row)
      this.express = row
      this.dialogVisible = true
    },
    search() {
      this.pageNum = 1
      this.getList()
    },
    resetSearch() {
      this.serchParams.classId = ''
      this.serchParams.times = []
      this.pageNum = 1
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
.text-color-red{
  color: #fd634e;
}
.text-color-green{
  color: #74d7d5;
}
.express-info {
  padding: 15px 20px;
}

.info-row {
  margin-bottom: 15px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-item {
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #ebeef5;
}

.info-item .label {
  font-weight: 600;
  color: #606266;
  font-size: 14px;
  display: inline-block;
  width: 100px;
}

.info-item .value {
  color: #303133;
  font-size: 14px;
}
</style>

